import React, { useEffect, useRef } from "react";

import { css, useTheme } from "@emotion/react";
import styled from "@emotion/styled";

import { red } from "../../../../utils/colors";
import Columns from "../../Columns";
import Container from "../../Container";
import Image from "../../Image";
import Markdown from "../../Markdown";
import ShapeContainer from "../../ShapeContainer";
import { SideNavContainer } from "../SideNavContainer";
import useSideNavStore from "../SideNavContainer/store";

const StyledContainer = styled(Container)`
    padding-top: 0;
    padding-bottom: 0;
`;

const StyledShapeContainer = styled(ShapeContainer)`
    margin-top: 0;
    margin-bottom: 0;
`;

const ImgContainer = styled.div`
    width: 100%;
`;

const ImgWrapper = styled.div`
    position: relative;
`;

const ThreeReasons = ({ name, items, image }) => {
    const imgRef = useRef();
    const theme = useTheme();
    const [paddingLeft] = useSideNavStore((state) => [state.paddingLeft]);

    const onScroll = () => {
        if (!imgRef.current) return;

        const y = imgRef.current.getBoundingClientRect().y;
        if (y >= -200 && y <= window.innerHeight) {
            imgRef.current.style.right =
                imgRef.current.getBoundingClientRect().y - 300 + "px";
        }
    };

    useEffect(() => {
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => {
            window.removeEventListener("scroll", onScroll);
        };
    }, [imgRef]);

    const BigHeadlineColumn = styled(Columns.Column)`
        display: flex;
        justify-content: flex-start;
        font-weight: 900;
        line-height: 0.9em;
        color: ${red};
        font-size: 10rem;
        ${theme.breakpoints.from.small.css`
            justify-content: center;
            font-size: 17rem;`};
        @media (max-width: 768px) {
            font-size: 8rem;
            font-weight: 800;
        }
    `;

    const SmallHeadlineColumn = styled(Columns.Column)`
        padding-top: 22px;
        font-weight: 900;
        line-height: 1.3em;
        color: ${red};
        font-size: 2rem;
        ${theme.breakpoints.from.small.css`
            font-size: 3.5rem;
        `};
        @media (max-width: 768px) {
            font-size: 1.8rem;
            font-weight: 800;
        }
    `;

    return (
        <StyledContainer>
            <StyledShapeContainer>
                <SideNavContainer
                    paddingLeft={paddingLeft}
                    css={css`
                        @media (min-width: 1850px) and (max-width: 1920px) {
                            padding-left: 0 !important;
                        }
                        @media (min-width: 1750px) and (max-width: 1850px) {
                            padding-left: 50px !important;
                        }
                        @media (min-width: 1661px) and (max-width: 1749px) {
                            padding-left: 0 !important;
                        }
                        @media (min-width: 1400px) and (max-width: 1660px) {
                            padding-left: ${Number(
                                paddingLeft.replace("px", "")
                            ) /
                                2 +
                            "px"} !important;
                        }
                    `}
                >
                    {name && (
                        <ShapeContainer.Headline>
                            <Columns className="is-mobile">
                                <BigHeadlineColumn mobile="4">
                                    3
                                </BigHeadlineColumn>
                                <SmallHeadlineColumn mobile="8" tablet="6">
                                    {name}
                                </SmallHeadlineColumn>
                            </Columns>
                        </ShapeContainer.Headline>
                    )}
                    <Columns>
                        {items.map((item, i) => (
                            <Columns.Column tablet="4" key={i}>
                                <div
                                    css={{
                                        fontSize: "1.5em",
                                        fontWeight: 900,
                                    }}
                                >
                                    {item.name}
                                </div>
                                <Markdown>{item.text}</Markdown>
                            </Columns.Column>
                        ))}
                    </Columns>
                </SideNavContainer>
                {image?.src && (
                    <ImgContainer>
                        <ImgWrapper ref={imgRef}>
                            <Image {...image} />
                        </ImgWrapper>
                    </ImgContainer>
                )}
            </StyledShapeContainer>
        </StyledContainer>
    );
};

export default ThreeReasons;
